/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/229-tongue2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zM5 4a1 1 0 110 2 1 1 0 010-2zm7 6h-1v1.5a1.5 1.5 0 01-3 0V10H4V9h8v1zm-1-4a1 1 0 110-2 1 1 0 010 2z"/>'
  }
})
